export var LangCodes;

(function (LangCodes) {
  LangCodes["ru_RU"] = "ru_RU";
  LangCodes["en_GB"] = "en_GB";
})(LangCodes || (LangCodes = {}));